const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isUuid(value: string | null | undefined): value is string {
  if (!value) return false;
  return UUID_REGEX.test(value.trim());
}

export function toUuidOrNull(value: string | null | undefined): string | null {
  if (!value) return null;
  const trimmed = value.trim();
  return UUID_REGEX.test(trimmed) ? trimmed : null;
}

/**
 * Masks a UUID or raw identifier with a fallback label.
 * If the value looks like a UUID, returns the fallback.
 * Otherwise returns the original value (or empty string if falsy).
 */
export function displayIdentity(value: unknown, fallback: string): string {
  const text = typeof value === "string" ? value.trim() : "";
  if (!text) return fallback;
  return isUuid(text) ? fallback : text;
}

/**
 * Replaces any UUID pattern within a string with '[ID]'.
 * Use to sanitize strings that may contain embedded UUIDs.
 */
export function maskUuids(text: string): string {
  if (!text) return text;
  return text.replace(UUID_REGEX, "[ID]");
}
